/** Fin d'affichage de la billetterie : 31/10/2026 à 23h00 (heure locale). */
export const TICKETING_END = new Date(2026, 9, 31, 23, 0, 0, 0);

export const TICKETING_URL = 'https://www.billetweb.fr/multi_event.php?multi=46755&color=E6C300';
export const TICKETING_WIDGET_SCRIPT = 'https://www.billetweb.fr/js/export.js';

export const isTicketingOpen = (): boolean => Date.now() <= TICKETING_END.getTime();
